import { UserTypeConstants } from "../types/UserTypeConstants";

let user = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : {};
const initialState = user
  ? {
      loggedIn: false,
      user: user,
      isEmailValidated: false,
      secretQuestion: [],
      mobileNo: "",
      isSecretQuesValidated: false,
      isPasswordUpdated: false,
      isSendOTPSuccess: false,
      isSendOTPError: false,
      isOTPvalidated: false,
    }
  : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case UserTypeConstants.LOGIN_REQUEST: {
      state.isPasswordUpdated = false;
      state.isSecretQuesValidated = false;
      state.isEmailValidated = false;
      state.secretQuestion = [];
      state.mobileNo = "";
      state.id = "";
      state.loggingIn = false;
      state.isSendOTPSuccess = false;
      state.isSendOTPError = false;
      state.isOTPvalidated = false;
      return state;
    }
    case UserTypeConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user.user,
      };
    case UserTypeConstants.LOGIN_FAILURE:
      return { loggedIn: false };
    case UserTypeConstants.LOGOUT:
      return { loggedIn: false, user: null };
    case UserTypeConstants.VERIFY_USER:
      return {
        loggedIn: true,
        user: action.user,
      };
    case UserTypeConstants.VALIDATE_EMAIL_SUCCESS: {
      state.isEmailValidated = true;
      state.secretQuestion = action.data.secretQuestion;
      state.mobileNo = action.data.mobileNo;
      state.id = action.data.id;
      return state;
    }
    case UserTypeConstants.VALIDATE_SECRET_QUESTION_REQUEST: {
      state.isSecretQuesValidated = false;
      return state;
    }
    case UserTypeConstants.VALIDATE_SECRET_QUESTION_SUCCESS: {
      state.isSecretQuesValidated = true;
      return state;
    }
    case UserTypeConstants.UPDATE_PASSWORD: {
      state.isPasswordUpdated = true;
      return state;
    }
    case UserTypeConstants.SEND_OTP_REQUEST: {
      state.isSendOTPSuccess = false;
      state.isSendOTPError = false;
      return state;
    }
    case UserTypeConstants.SEND_OTP_SUCCESS: {
      state.isSendOTPSuccess = true;
      return state;
    }
    case UserTypeConstants.SEND_OTP_FAILIURE: {
      state.isSendOTPError = true;
      return state;
    }
    case UserTypeConstants.VALIDATE_OTP_REQUEST: {
      state.isOTPvalidated = false;
      return state;
    }
    case UserTypeConstants.VALIDATE_OTP_SUCCESS: {
      state.isOTPvalidated = true;
      return state;
    }
    case UserTypeConstants.VALIDATE_OTP_FAILIURE: {
      state.isOTPvalidated = false;
      return state;
    }

    default:
      return state;
  }
}
